import axios from "axios";
import cookie from "cookie";
import dayjs from "dayjs";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { zIndex } from "styles/zIndex";

import { IconBox } from "../IconBox";

const link = "https://support.mix.day/dee2c9ae-495a-4672-8aa2-3fcc9d5feb77";

export const TopBanner = ({
    text,
    url,
    endDate
}: {
    text: string | undefined;
    url: string | undefined;
    endDate: string | undefined;
}) => {
    const [isTopBannerOpen, setIsTopBannerOpen] = useState(false);

    useEffect(() => {
        // Guard against SSR
        if (typeof document === "undefined") return;

        // Generate a unique banner ID based on endDate for this specific banner
        const bannerId = endDate || "default";
        const localStorageKey = `mix/topbanner-closed-${bannerId}`;

        // Check localStorage first (works in both web and extension)
        const closedInLocalStorage =
            localStorage.getItem(localStorageKey) === "true";

        // Check cookies (fallback for web app compatibility)
        const cookieKey = "mix/topbanner";
        const cookies = document.cookie;
        const exposedInCookie = cookie.parse(cookies)[cookieKey] === "true";

        const inRange = dayjs().isBefore(endDate);

        // Show banner only if not closed in localStorage, not exposed via cookie, and within date range
        if (!closedInLocalStorage && !exposedInCookie && inRange) {
            setIsTopBannerOpen(true);
        }
    }, [endDate]);

    const handleCloseButtonClick = () => {
        // Generate the same banner ID
        const bannerId = endDate || "default";
        const localStorageKey = `mix/topbanner-closed-${bannerId}`;

        // Store close state in localStorage (works in extension)
        localStorage.setItem(localStorageKey, "true");

        // Try to call API for web app (will fail silently in extension)
        axios
            .post("/api/hide_topbanner", {
                interval: 1
            })
            .catch(() => {
                // Silently fail in extension context where API routes don't exist
            });

        setIsTopBannerOpen(false);
    };

    return isTopBannerOpen ? (
        <div className="flex items-center justify-end bg-[#343862] px-4">
            <a
                href={url || link}
                target="_blank"
                rel="noreferrer"
                className="relative flex h-16 w-full items-center justify-center
                    bg-[#343862] bg-[length:580px] bg-center bg-no-repeat
                    text-[16px] md:h-[70px] md:bg-[length:280px]"
                style={{ zIndex: zIndex.header }}
                dangerouslySetInnerHTML={{ __html: text || "" }}
            />
            <XIcon
                className="m-4 mr-3 size-6 cursor-pointer p-0.5 text-white"
                onClick={handleCloseButtonClick}
            />
        </div>
    ) : (
        <></>
    );
};
